import { getSite } from '@/core/api'
export default {
  namespaced: true,
  state: {
    footer: sessionStorage.getItem('footer')
      ? JSON.parse(sessionStorage.getItem('footer'))
      : false,
    homeCeramics: sessionStorage.getItem('homeCeramics')
      ? JSON.parse(sessionStorage.getItem('homeCeramics'))
      : false,
    homeInformation: sessionStorage.getItem('homeInformation')
      ? JSON.parse(sessionStorage.getItem('homeInformation'))
      : false,
    logoUrl: sessionStorage.getItem('logoUrl')
      ? JSON.parse(sessionStorage.getItem('logoUrl'))
      : false,
    friendlyLink: sessionStorage.getItem('friendlyLink')
      ? JSON.parse(sessionStorage.getItem('friendlyLink'))
      : false,
    title: sessionStorage.getItem('title')
      ? JSON.parse(sessionStorage.getItem('title'))
      : false,
    keywords: sessionStorage.getItem('keywords')
      ? JSON.parse(sessionStorage.getItem('keywords'))
      : false,
    tickets: sessionStorage.getItem('tickets')
      ? JSON.parse(sessionStorage.getItem('tickets'))
      : false,
    kilns: sessionStorage.getItem('kilns')
      ? JSON.parse(sessionStorage.getItem('kilns'))
      : false
  },
  mutations: {
    getHome(state, site) {
      state.footer = site.base.footer
      state.homeCeramics = site.official.ceramics
      state.homeInformation = site.official.information
      state.logoUrl = site.base.logo_url
      state.friendlyLink = site.base.links
      state.title = site.base.title
      state.keywords = site.base.keywords
      state.tickets = site.official.tickets
      state.kilns = site.official.kilns
      sessionStorage.setItem('footer', JSON.stringify(site.base.footer))
      sessionStorage.setItem(
        'homeCeramics',
        JSON.stringify(site.official.ceramics)
      )
      sessionStorage.setItem(
        'homeInformation',
        JSON.stringify(site.official.information)
      )
      sessionStorage.setItem('logoUrl', JSON.stringify(site.base.logo_url))
      sessionStorage.setItem('friendlyLink', JSON.stringify(site.base.links))
      sessionStorage.setItem('title', JSON.stringify(site.base.title))
      sessionStorage.setItem('keywords', JSON.stringify(site.base.keywords))
      sessionStorage.setItem('tickets', JSON.stringify(site.official.tickets))
      sessionStorage.setItem('kilns', JSON.stringify(site.official.kilns))
    }
  },
  actions: {
    // 获取首页数据
    async getHome({ commit }) {
      if (sessionStorage.getItem('site')) {
        return false
      }
      let res = await getSite()
      // console.log(res) // eslint-disable-line no-console
      if (res.status === 200) {
        commit('getHome', res.data)
      }
    }
  },
  getters: {
    footer: state => {
      return state.footer
    },
    homeCeramics: state => {
      return state.homeCeramics
    },
    homeInformation: state => {
      return state.homeInformation
    },
    logoUrl: state => {
      return state.logoUrl
    },
    friendlyLink: state => {
      return state.friendlyLink
    },
    title: state => {
      return state.title || '北大智慧生物样本资源中心'
    },
    keywords: state => {
      return state.keywords
    },
    tickets: state => {
      return state.tickets
    },
    kilns: state => {
      return state.kilns
    }
  }
}
